import React from 'react';

const PhotoGallery = () => {
  const photos = [
    {
      src: 'img/L-R-Pacific-Northwest-Ballet-corps-de-ballet-dancer-Noah-Martzall-and-sololist-Madison-Rayn-Abeo-in-Kiyon-Rosss-…throes-of-increasing-wonder-Photo-by-Angela-Sterling-s1f1c1-1280x640.jpg',
      alt: 'A scene from Swan Lake',
      caption: 'The iconic White Swan pas de deux from our production of Swan Lake.'
    },
    {
      src: 'img/local-and-entertainment-pic-John-Batista-748x486-PNBSwanB22-0374.jpg',
      alt: 'A dancer in a vibrant Don Quixote costume',
      caption: 'The fiery energy of Don Quixote, captured in a moment of dramatic flair.'
    },
    {
      src: 'img/Pacific%20Northwest%20Ballet%20School.jpg',
      alt: 'The Sugar Plum Fairy from The Nutcracker',
      caption: 'The magical Kingdom of Sweets from our beloved holiday classic, The Nutcracker.'
    },
    {
      src: 'img/Pacific-Northwest-Ballet-in-Wartime-Elegy-part-of-Love-Loss.jpg',
      alt: 'Dancers in a contemporary piece',
      caption: 'Exploring new movements in a powerful contemporary work commissioned by NBT.'
    },
    {
      src: 'img/Pacific-Northwest-Ballet-Principal-Dancer-Noelani-Pantastico-in-Jean-Christophe-Maillots-Romeo-et-Juliette.-Photo-by-Angela-Sterling..jpg',
      alt: 'A ballerina tying her pointe shoes backstage',
      caption: 'A quiet moment of preparation backstage before the curtain rises.'
    },
    {
      src: 'img/Pacific-Northwest-Ballet-Review-Nutcracker-December-2021-1140x570.jpg.webp',
      alt: 'The corps de ballet in perfect unison',
      caption: 'The precision and grace of the NBT Corps de Ballet.'
    },
    {
      src: 'img/pacific-northwest-ballet.jpg',
      alt: 'A whimsical scene from A Midsummer Night\'s Dream',
      caption: 'Puck\'s mischief unfolds in our enchanting production of A Midsummer Night\'s Dream.'
    },
    {
      src: 'img/pacificnorthwestballet.jpg',
      alt: 'A young student in a ballet class',
      caption: 'Nurturing the next generation of dancers at the Northwest Ballet Academy.'
    }
  ];

  return (
    <div className="container-custom py-12">
      <h1 className="text-4xl font-bold font-elegant text-ballet-burgundy mb-4 text-center">NBT Photo Gallery</h1>
      <p className="text-lg text-gray-700 mb-12 text-center max-w-3xl mx-auto">
        A glimpse into the artistry, dedication, and magic of the Northwest Ballet Theater. Explore moments from our performances, rehearsals, and community events.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {photos.map((photo, index) => (
          <div key={index} className="bg-white rounded-lg shadow-elegant overflow-hidden group transform hover:-translate-y-2 transition-transform duration-300">
            <img
              src={photo.src}
              alt={photo.alt}
              className="w-full h-64 object-cover"
            />
            <div className="p-4">
              <p className="text-sm text-gray-700">{photo.caption}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PhotoGallery;
